import axios, { AxiosResponse } from "axios";
import PreSignedUrlParamsRequest from "~~/package/apis/recorde/request/PreSignedUrlParamsRequest";
import PreSignedUrlResponse from "~~/package/apis/recorde/response/PreSignedUrlResponse";

export default class RecordeApi {
    public async getPreSignedUrl(params: PreSignedUrlParamsRequest): Promise<string> {
        const response: AxiosResponse<PreSignedUrlResponse> = await axios.get("https://cheating-video.codepresso.io/urls", { params });
        return response.data.presigned_url;
    }

    public async uploadVideo(preSignedUrl: string, videoFile: Blob): Promise<void> {
        await axios.put(preSignedUrl, videoFile, {
            headers: {
                'Content-Type': 'video/webm',
            }
        });
    }

    public async upload(preSignedUrl: string, body: Blob, contentType: string): Promise<void> {
        await axios.put(preSignedUrl, body, { headers: { 'Content-Type': contentType } });
    }
}
